import { render, staticRenderFns } from "./ConfirmarFotoCapturada.vue?vue&type=template&id=19dc4fe0&scoped=true&"
import script from "./ConfirmarFotoCapturada.vue?vue&type=script&lang=js&"
export * from "./ConfirmarFotoCapturada.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarFotoCapturada.vue?vue&type=style&index=0&id=19dc4fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc4fe0",
  null
  
)

export default component.exports